import { EXERCISES_DOMAIN } from '../../exercise/redux/constants'
import { MESSAGES_DOMAIN } from '../../message'

export const REDUX_SHOULD_SORT = {
  [EXERCISES_DOMAIN]: false
}

export const REDUX_SORT_ORDER = {
  ASC: 'ASC',
  DESC: 'DESC'
}
export const REDUX_DOMAIN_TO_SORT_ORDER = {
  [MESSAGES_DOMAIN]: 'ASC'
}

export const REDUX_SORT_KEYS = {}

export const REDUX_DOMAIN_TO_SORT_KEYS = {}
